import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CreateOrganizationDialogComponent } from '../../../components/utility/create-organization-dialog/create-organization-dialog.component';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { routes } from '../../../constants/routes';
import { unsubscribe } from '../../../decorators/unsubscribe.decorator';
import { ApiErrorHandler } from '../../../models/api-error-handler.model';
import { ApiService } from '../../../services/api.service';
import { SeoService } from '../../../services/seo.service';
import { ToasterService } from '../../../services/toaster.service';
import { UtilityService } from '../../../services/utility.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-login-options',
  standalone: true,
  templateUrl: './login-options.component.html',
  styleUrl: './login-options.component.scss',
  imports: [NgClass, RouterLink],
})
@unsubscribe()
export class LoginOptionsComponent
  implements OnInit, OnDestroy, ApiErrorHandler
{
  private meriPehchanUrl!: string;
  private parichayUrl!: string;
  private nssoAuthSubs?: Subscription;
  private parichayAuthSubs?: Subscription;

  chosenActiveMethod: string | null = null;
  routes = routes;
  // Login methods with active status and expiry date
  loginMethods = [
    {
      id: 'email-otp',
      title: 'Individual ( Email OTP )',
      description: 'Login with your Email to start exploring AIKosh',
      icon: 'images/email-auth.svg',
      logo: null,
      isActive: true,
      expiryDate: '31st October 2026',
      name: 'Email OTP',
    },
    {
      id: 'jan-parichay',
      title: 'Individual ( Jan Parichay )',
      description:
        'Login with Jan Parichay as it supports Digilocker and Parichay so you can still login easily',
      icon: 'images/individual-auth.svg',
      logo: 'images/jan-parichay.svg',
      isActive: true,
      name: 'Jan Parichay',
      showBetaTag: false,
    },
    {
      id: 'meri-pehchaan',
      title: 'Individual ( Meri Pehchaan )',
      description: 'Login with Meri Pehchaan and explore as an individual user',
      icon: 'images/individual-auth.svg',
      logo: 'images/meripehchaan-logo.svg',
      isActive: true,
      expiryDate: '31st October 2026',
      name: 'Meri Pehchaan',
    },
    {
      id: 'parichay',
      title: 'For Govt. Employee Only',
      description: 'Login With Parichay',
      icon: 'images/govt-auth.svg',
      logo: 'images/parichay.png',
      isActive: true,
      expiryDate: '31st October 2026',
      name: 'Parichay',
    },
  ];

  constructor(
    private matDialog: MatDialog,
    public toaster: ToasterService,
    private apiService: ApiService,
    private utilService: UtilityService,
    private seoService: SeoService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const { title, description, canonicalUrl } = pageSeoInfo['option'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
  }

  onIndividualLogin() {
    this.getMeriPehchaanUrl();
  }

  onOrganizationLogin() {
    this.matDialog
      .open(CreateOrganizationDialogComponent, {
        autoFocus: false,
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.getMeriPehchaanUrl();
        }
      });
  }

  getMeriPehchaanUrl() {
    this.nssoAuthSubs = this.apiService.fetchNssoAuth().subscribe({
      next: (res) => {
        this.meriPehchanUrl = res;
        this.utilService.openExternalPage(this.meriPehchanUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  getJanParichayUrl() {
    this.parichayAuthSubs = this.apiService.fetchJanParichayAuth().subscribe({
      next: (res) => {
        this.parichayUrl = res;
        this.utilService.openExternalPage(this.parichayUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  getParichayUrl() {
    this.parichayAuthSubs = this.apiService.fetchParichayAuth().subscribe({
      next: (res) => {
        this.parichayUrl = res;
        this.utilService.openExternalPage(this.parichayUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  goToRegister() {
    this.router.navigate(['/', routes.account, routes.register, routes.step1]);
  }

  onIndividualEmailLogin() {
    this.router.navigate([
      '/',
      routes.account,
      routes.user,
      routes.verifyEmail,
    ]);
  }

  proceedToLogin(methodId: string, isActive: boolean) {
    // if (!isActive) {
    //   this.chosenActiveMethod = methodId;
    //   return;
    // }

    this.chosenActiveMethod = null;

    switch (methodId) {
      case 'jan-parichay':
        this.getJanParichayUrl();
        break;
      case 'email-otp':
        this.onIndividualEmailLogin();
        break;
      case 'meri-pehchaan':
        this.onIndividualLogin();
        break;
      case 'parichay':
        this.getParichayUrl();
        break;
      default:
        break;
    }
  }

  goBack() {
    this.chosenActiveMethod = null;
  }

  getChosenMethod() {
    return this.loginMethods.find((m) => m.id === this.chosenActiveMethod);
  }

  ngOnDestroy() {
    this.nssoAuthSubs?.unsubscribe();
    this.parichayAuthSubs?.unsubscribe();
  }
}
